import React, {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from "react-router";
import { EditOutlined } from '@mui/icons-material';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';

import { getMimarConstantsRequest } from '../../../store/Settings/actions'
import messages from "../../../assets/locale/messages";
import { ROUTE_PATHS } from '../../../utils/RoutesPaths';
import { setPageMainTitle } from '../../../utils/Helpers';
import { isSuperAdmin } from '../../../utils/Permissions';
import Switch from '../../../components/Switch';
import Button from '../../../components/Button';

const MimarConstants = () => {

    
    const dispatch = useDispatch();
    const lang = useSelector((state) => state.locale.lang);
    const mimarConstansts = useSelector((state) => state.settings.mimarConstansts);
    const { settings, shared } = messages[lang];
    const history = useHistory();

    console.log(mimarConstansts)
    
    useEffect(() => {
        setPageMainTitle('SettingsManagment');
        dispatch(getMimarConstantsRequest())
    }, [])

    return (
        <div>
            <div className="d-flex justify-content-between mb-4">
                <span className="fsize-30 fweight-600 d-flex gap-1 text-primary"
                >
                    <span
                        className="pointer"
                        onClick={()=>{
                            history.push(ROUTE_PATHS.settings)
                        }} 
                    >
                        { lang === 'en' ? 
                            (<ArrowBackIosOutlinedIcon/>) : 
                            (<ArrowForwardIosOutlinedIcon/>)
                          }
                    </span>
                    <span  className="mt-1">{settings.viewSettings.mimarConstants}</span>
                </span> 
                {isSuperAdmin() && (
                    <Button
                    label={<span className="d-flex gap-1 px-2">
                                <span><EditOutlined fontSize="small" /></span>
                                <span>{shared.edit}</span>
                            </span>}
                    labelClass="fsize-16 text-white py-1"
                    onClick={() => {history.push(ROUTE_PATHS.editMimarConstants)}}
                />
                )}
            </div>
            
            <div className="bg-white rounded-4 px-5 py-4  mb-4 fsize-18 fweight-400">
                <div className="mb-1 fsize-18 text-secondary">
                    {settings.mimarConstants.vat}
                </div>
                <div className="fweight-500 text-gray fsize-16">
                    {mimarConstansts.vat}
                </div>
            </div>
            <div className="bg-white rounded-4 px-5 py-4  mb-4 fsize-18 fweight-400">
                <div className="mb-1 fsize-18 text-secondary">
                    {settings.mimarConstants.onlineFees}
                </div>
                <div className="fweight-500 text-gray fsize-16">
                    {mimarConstansts.onlineFees}
                </div>
            </div>
            <div className="bg-white rounded-4 px-5 py-4  mb-4 fsize-18 fweight-400">
                <div className="mb-1 fsize-18 text-secondary">
                    {settings.mimarConstants.mimarCommission}
                </div>
                <div className="fweight-500 text-gray fsize-16">
                    {mimarConstansts.mimarsCommission}
                </div>
            </div>
            <div className="bg-white rounded-4 px-5 py-4  mb-4 fsize-18 fweight-400">
                <div className="mb-1 fsize-18 text-secondary">
                    {settings.mimarConstants.fixedFees}
                </div>
                <div className="fweight-500 text-gray fsize-16">
                    {mimarConstansts.fixedFees}
                </div>
            </div>
            <div className="bg-white rounded-4 px-5 py-4  mb-4 fsize-18 fweight-400">
                <div className="mb-1 fsize-18 text-secondary">
                    {settings.mimarConstants.commissionStartsAfter}
                </div>
                <div className="fweight-500 text-gray fsize-16">
                    {mimarConstansts.commissionThreshold}
                    <span className="text-primary fweight-700 mx-2 fsize-15">{settings.mimarConstants.completedPaidAppointments}</span>
                </div>
            </div>
                    
        </div>
    )
}

export default MimarConstants